import React, {useEffect, useState} from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {FormattedMessage, injectIntl} from "react-intl";

import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import AddCircleIcon from "@mui/icons-material/AddCircle";

import {changeCartItemQuantity} from "../../../actions/actionFunctions";
import {cartItemInterface} from "../../shoppingCart/cartItemInterface";
// import {featureIsBundle} from "../lookNavigation/lookFunctions2";
import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS} from "../../../analytics";
import LookFeatureQuantityText from "./lookFeatureQuantityText";
import {pricingIsLocked} from "../lookNavigation/lookNavigationFunctions";
import {getDbFeatureProperty, shouldUseLixilAvailableQty} from "../lookNavigation/lookFunctions2";

const LookFeatureQuantity = (props) => {

  const {cartItem, changeCartItemQuantity, propsQuantity, isEmpty, id, intl, cItemsAddedToParentCart,
    fabricatorSettings} = props;
  const [quantity, setQuantity] = useState("");

  const useLixilQuantity = shouldUseLixilAvailableQty(fabricatorSettings, cartItem ? cartItem.cartFeature : null);

  const MAX = useLixilQuantity && cartItem.cartFeature && cartItem.cartFeature.dbFeature[getDbFeatureProperty("lixilAvailableQty")] > 0
    ? cartItem.cartFeature.dbFeature[getDbFeatureProperty("lixilAvailableQty")]
    : 99999;
  const MIN = 0;

  const allowDecimals = false;

  const updateQuantity = (quan) => {
    setQuantity(quan);
  };

  useEffect(() => {
    if (cartItem && cartItem.cartFeature) {
      updateQuantity(cartItem.quantity || 0);
    } else if (isEmpty) {
      updateQuantity("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEmpty, id, propsQuantity]); // (remove value if cart item was deleted)

  const handleInputChange = (e, fromButton = "") => {

    if (cartItem.isMinimumCharge) {
      return false
    }

    let value = "" + e.target.value;

    if (value.includes(".")) {
      if (!allowDecimals) {
        return false
      }
      if (value.split(".")[1].length > 2) {
        value = +value.substring(0, value.length - 1); //round to 2 decimals
      }
    }

    value = parseInt(value) || 0;

    if (value <= MAX) {
      value = value < MIN ? MIN : value;
    } else if (value !== MAX) {
      value = MAX
    }

    const featureLabel = Analytics.getSkuForAnalytics(cartItem.cartFeature);
    const analyticsAdjust = fromButton ? fromButton + "-" + value : "input-" + value;
    Analytics.sendClickEvent(`${LOOK_JOURNEY_ANALYTIC_EVENTS.lookListCartItemQuantityChange + featureLabel}-${analyticsAdjust}`);

    updateQuantity(value);
    if (!cartItem.isEmpty) {
      // if (featureIsBundle(cartItem.cartFeature, cartItems)) {
      //   cartItems.forEach(cItem => {
      //     if (cItem.relatedProductParent && cItem.relatedProductParent.dbFeature.id === cartItem.cartFeature.dbFeature.id) {
      //       let newQuantity = (fromButton === "plus")
      //         ? cItem.quantity + 1
      //         : (fromButton === "minus")
      //           ? cItem.quantity - 1
      //           : value;
      //       newQuantity = newQuantity < MIN ? MIN : newQuantity;
      //       changeCartItemQuantity(cItem , newQuantity);
      //     }
      //   })
      // }
      changeCartItemQuantity(cartItem, value);
    }
  };

  const handleOnKeyDown = (event) => {
    if (event.key==='.' && !allowDecimals) {
      event.preventDefault();
      return false
    }
  };

  const {isLixil} = pricingIsLocked();

  return (
    <div className="ll-quantity">
      <span className="ll-quantity__text">
        {isLixil ? <FormattedMessage id="look.list.feature.quantity"/> : <LookFeatureQuantityText cartItem={cartItem}/>}
      </span>
      <div className="ll-quantity__actions">
        {useLixilQuantity && (quantity === MAX) ? (
          <span className="lm-stock lm-stock--red ll-quantity__max-stock">
            <FormattedMessage values={{quantity: cartItem.cartFeature.dbFeature[getDbFeatureProperty("lixilAvailableQty")]}} id="look.list.feature.maxStock"/>
          </span>
        ) : null}
        <IconButton aria-label={intl.formatMessage({id:"look.list.header.printButton"})}
                    onClick={() => {
                      handleInputChange({target: {value: quantity - 1}}, "minus")
                    }}
                    className="look-icon look-icon--small">
          <RemoveCircleIcon />
        </IconButton>
        <TextField className={"ll-quantity__input" + (quantity === MAX ? " ll-quantity__input--red" : "")}
                   label=""
                   variant="outlined"
                   size="small"
                   type="number"
                   value={quantity}
                   pattern="^\d+(?:\.\d{1,2})?$"
                   onKeyDown={handleOnKeyDown}
                   onChange={handleInputChange}/>
        <IconButton aria-label={intl.formatMessage({id:"look.list.header.printButton"})}
                    disabled={quantity === MAX}
                    onClick={() => {
                      handleInputChange({target: {value: quantity + 1}}, "plus")
                    }}
                    className="look-icon look-icon--small">
          <AddCircleIcon />
        </IconButton>
        {cItemsAddedToParentCart.includes(cartItem.id) ? (
          <span className="lm-stock lm-stock--red ll-quantity__in-cart">
            <FormattedMessage values={{items: cartItem.quantity}} id="look.list.feature.addedToCart"/>
          </span>
        ) : null}
      </div>
    </div>
  )
};

LookFeatureQuantity.propTypes = {
  cartItem: PropTypes.shape(cartItemInterface)
}

const mapStateToProps = (store, ownProps) => {
  const {cartItems, cItemsAddedToParentCart} = store.cartState;

  return {
    isEmpty: ownProps.cartItem.isEmpty,
    id: ownProps.cartItem.id,
    propsQuantity: ownProps.cartItem.quantity,
    cartItems,
    cItemsAddedToParentCart,
    fabricatorSettings: store.fabricatorState.settings,
  }
};

const mapDispatchToProps = {
  changeCartItemQuantity
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(LookFeatureQuantity)
)
